var React = require('react');

function CalendarBlackInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"--icon--start"},React.createElement("path",{"id":"calendar","d":"M16.8002 0V2.4H7.20019V0H4.8002V2.4H3.6002C2.2682 2.4 1.2122 3.48 1.2122 4.8L1.2002 21.6C1.2002 22.92 2.2682 24 3.6002 24H20.4002C21.7202 24 22.8002 22.92 22.8002 21.6V4.8C22.8002 3.48 21.7202 2.4 20.4002 2.4H19.2002V0H16.8002ZM20.4002 21.6H3.6002V8.4H20.4002V21.6Z","fill":"black"})));
}

CalendarBlackInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CalendarBlackInline;

CalendarBlackInline.default = CalendarBlackInline;
